// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SchemaForm } from "@components";

type Props = $Exact<{
  formRef: *,
  data: ?Object,
  schema: ?Object,
  onSubmit: (data: Object) => void,
}>;

export class AlertTypeForm extends React.Component<Props> {
  get schema() {
    const alertType = (this.props.schema || {}).properties.alertType;
    if (!alertType) {
      return null;
    }

    return {
      type: "object",
      required: ["alertType"],
      properties: {
        alertType,
      },
    };
  }

  render() {
    return (
      <SchemaForm
        ref={this.props.formRef}
        className="w-100"
        formData={this.props.data || {}}
        schema={this.schema || {}}
        onSubmit={this.props.onSubmit}
        externalSubmit
      >
        <div className="d-flex justify-content-center" />
      </SchemaForm>
    );
  }
}

export default localize()(AlertTypeForm);
